window.FocusTrap = (function () {
    const FOCUSABLE = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let active = null;

    function getFocusable(container) {
        return Array.from(container.querySelectorAll(FOCUSABLE))
            .filter(el => el.offsetParent !== null || el === document.activeElement);
    }

    function handleKeydown(e) {
        if (!active || e.key !== 'Tab') return;
        const focusable = getFocusable(active.container);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    return {
        activate(container) {
            if (!container || active?.container === container) return;
            const trigger = document.activeElement;
            const focusable = getFocusable(container);
            (container.querySelector('[data-autofocus]') || focusable[0] || container).focus();
            document.addEventListener('keydown', handleKeydown, true);
            active = { container, trigger };
        },
        release() {
            if (!active) return;
            document.removeEventListener('keydown', handleKeydown, true);
            if (active.trigger && typeof active.trigger.focus === 'function') {
                active.trigger.focus();
            }
            active = null;
        }
    };
})();
